<div [class]="customClass">{{ text }}</div>
